import { TableAPIService } from '@project/store/Table';
import { Table, TableAPIController } from './Table/Table';
import { TableQueryOptions } from './Table/TableQuery';
import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from 'mobx';
import { FilterValue } from '@project/components/Module/Table/Filters/FilterInput/types';

export class TableCollection {
  @observable private _list = new Map<string, TableAPIController>();

  private _INITIAL_QUERY: TableQueryOptions = {
    pageSize: 10,
    page: 1,
    filterFields: {},
    order: {
      direction: 'ascend',
      field: 'id',
    },
  };

  constructor() {
    makeObservable<TableCollection>(this);
  }

  @computed get list() {
    return this._list;
  }

  set = async (id: string, filterParams?: FilterValue) => {
    const cachedTable = this._list.get(id);

    if (cachedTable) return;

    const response = await this._load(id, {
      ...this._INITIAL_QUERY,
      filterFields: filterParams ?? {},
    });
    const table = new Table(response);
    const controller = new TableAPIController({ table });

    runInAction(() => {
      this._list.set(id, controller);
    });
  };

  @action delete = (id: string) => {
    this._list.delete(id);
  };

  private _load = async (tableId: string, query: TableQueryOptions) => {
    const service = new TableAPIService();

    const columns = await service.loadColumns(tableId);
    const info = await service.loadInfo(tableId);

    const { _count, features } = await service.loadRecords(
      tableId,
      query,
      columns,
    );

    return {
      columns,
      info,
      total: _count,
      records: features,
      initialQuery: query,
    };
  };
}
